<ng-container>
    <div>
      <div style="margin-left: 70%;  margin-bottom: 2%">
        <!-- <button
        [useExistingCss]="true"
          class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
          printSectionId="print-section" ngxPrint>
          print
        </button> -->

       <button class="noPrint"
        style="margin-right: 2%; margin-left: 2%"
        mat-raised-button color="primary"
        (click)="printPage()">
         Print
       </button>

        <button class="noPrint" style="margin-top: 2% 2% 0 2%;"
          (click)="exportExcel('Representative_Taluka_Bussiness_Report')" mat-raised-button color="primary">
          Export
        </button>
        <button mat-dialog-close class="btn noPrint">
          Close
        </button>
      </div>
    </div>
    <div>
      <div class="container" id="print-section">
        <table class="table table-bordered"  style="table-layout: auto; width: 100%;">
          <thead>

             <tr>
            <th [attr.colspan]="totalth - 3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ today | date:'dd-MM-yyyy' }}
            </th>
          </tr>

            <tr>
            <th [attr.colspan]="totalth - 6" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              नोंदणीदार, सर्व प्रतिनीधी, वितरण, सर्व एकत्रित वर्गणीदार यादी वर्गणी - वर्गणी जमा असलेले आणि बाकी असललेले
               <!-- <span *ngIf="appliedFilters">
                    <small>
                         <span *ngIf="appliedFilters.country && appliedFilters.country.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>देश:</strong> <strong>{{ appliedFilters.country }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.state && appliedFilters.state.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>राज्य:</strong> <strong>{{ appliedFilters.state }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.district && appliedFilters.district.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>जिल्हा:</strong> <strong>{{ appliedFilters.district }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.taluka && appliedFilters.taluka.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>तालुका:</strong> <strong>{{ appliedFilters.taluka }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.subscriptionType && appliedFilters.subscriptionType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>वर्गणी प्रकार:</strong> <strong>{{ appliedFilters.subscriptionType }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.rep && appliedFilters.rep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रतिनिधी:</strong> <strong>{{ appliedFilters.rep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.officerep && appliedFilters.officerep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>कार्यालय प्रतिनिधी:</strong> <strong>{{ appliedFilters.officerep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.prant && appliedFilters.prant.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रांत:</strong> <strong>{{ appliedFilters.prant }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.receiptType && appliedFilters.receiptType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>पावती प्रकार:</strong> <strong>{{ appliedFilters.receiptType }}</strong>
                        </span>	 

                    </small>
                </span> -->
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ startDate | date:'dd-MM-yyyy' }}
            </th>
            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              पर्यंत - {{ endDate | date:'dd-MM-yyyy' }}
            </th>
          </tr>

            <tr>
                <th [attr.colspan]="totalth - 6" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              तालुका निहाय वितरण सांकेतानुसार 
              </th>
            </tr>


            <tr>
              <th style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">देश</th>
              <th style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">राज्य</th>
              <th style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">जिल्हा</th>
              <th style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">तालुका</th>
              <!-- <th style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">पोस्ट वितरणाची यादी </th>
              <th style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">हस्ते वितरणाची यादी </th>
              <th style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">मॅगझीन वितरणाची यादी </th>
              <th style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">डिजीटल वितरणाची यादी </th> -->

             
              <!-- <ng-container *ngFor="let data of delivery_mode">
                <th *ngIf="data.isVisible" colspan="4" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ data.delivery_mode }}</th>
              </ng-container> -->
            </tr>
            <tr>
         
         
              <ng-container *ngFor="let data of subTypesName">
                <th *ngIf="data.isVisible" colspan="5" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ data.name }}</th>
              </ng-container>
            </tr>

            <tr>
               <th style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">देश</th>
              <th style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">राज्य</th>
              <th style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">जिल्हा</th>
              <th style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">तालुका</th>
         
              <ng-container *ngFor="let data of subTypesName">
                <th *ngIf="data.isVisible" style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">येणे</th>
                <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; word-wrap: break-word;">जमा</th>
                <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; word-wrap: break-word;">एकूण</th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
          
                



          </tbody>
        </table>
      </div>
    </div>
  
   
  </ng-container>
  <div *ngIf="isLoading" class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
  </div>